import { useState, useEffect, useCallback, useMemo } from "react";
import useRouteState from "src/share/hooks/useRouteState";

const dateRangeInit = {
  focus: null,
  startDate: null,
  endDate: null
};

export const useCasesDateRange = onDateRangeChange => {
  const { routeState } = useRouteState();
  const [dateRange, setDateRange] = useState<any>(dateRangeInit);
  const [showDatePicker, setShowDatePicker] = useState<boolean>(false);

  const handleDatePickerToogle = useCallback(() => {
    setShowDatePicker(prev => !prev);
  }, [showDatePicker]);

  useEffect(() => {
    if (routeState && routeState.options && routeState.options.range) {
      setDateRange({ ...routeState.options.range });
      setShowDatePicker(true);
    }
  }, []);

  const handleDateChange = useCallback(
    date => {
      if (dateRange.focus === "endDate") {
        setDateRange(prev => ({
          ...prev,
          endDate: date.endDate,
          focus: null
        }));
        if (dateRange.startDate) {
          onDateRangeChange({
            startDate: dateRange.startDate,
            endDate: date.endDate,
            focus: null
          });
        }
      }
      if (dateRange.focus === "startDate") {
        setDateRange(prev => ({
          ...prev,
          startDate: date.startDate,
          endDate: null
        }));
      }
    },
    [dateRange]
  );

  const handleDateFocus = useCallback(
    ({ focus }) => {
      setDateRange(prev => ({
        ...prev,
        ...(focus === "startDate" ? { endDate: null } : {}),
        focus
      }));
    },
    [dateRange]
  );

  const handleClearDateRange = useCallback(() => {
    setDateRange(dateRangeInit);
    setShowDatePicker(false);
  }, [dateRange, showDatePicker]);

  return useMemo(
    () => ({
      dateRange,
      showDatePicker,
      actions: {
        handleDateChange,
        handleDatePickerToogle,
        handleDateFocus,
        handleClearDateRange
      }
    }),
    [dateRange, showDatePicker]
  );
};



// WEBPACK FOOTER //
// ./src/modules/Case/View/hooks/useCasesDateRange.ts